import { C as CosmosIconChevronUp$1, d as defineCustomElement$1 } from './p-SHLJjLOh.js';

const CosmosIconChevronUp = CosmosIconChevronUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChevronUp, defineCustomElement };
